module.exports = __webpack_public_path__ + "static/About-icon-2-Geeks-3228b24702dc9b2ea1b206c148af4348.png";